import React, { useState } from "react";
import { useNavigate , useLocation } from "react-router"; 
import "./PageLogin.css";

const PageLogin = () => {
  const [mobile, setMobile] = useState("");
  const [otp, setOtp] = useState("");
  const [message, setMessage] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [showOtp, setShowOtp] = useState(false);
 const navigate = useNavigate(); 
 
const location = useLocation();
  // STEP 1: Send OTP
  const handleSendOtp = async () => {
    setMessage("");

    if (!mobile.trim()) {
      setMessage("Mobile number is required");
      return;
    }

    try {
      const response = await fetch(
        "https://gitstool.in/liquor/shop_app/send_otp.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            mob_no: mobile.trim(),
          }),
        }
      );

      const result = await response.json();
      console.log("Send OTP response:", result);

      if (result.status === "success") {
        setOtpSent(true);
        setMessage("OTP sent successfully");
      } else {
        setOtpSent(false);
        setMessage(result.message || "Failed to send OTP");
      }
    } catch (error) {
      console.error("Send OTP error:", error);
      setMessage("Error sending OTP");
    }
  };

  // STEP 2: Verify OTP
  const handleVerifyOtp = async () => {
    setMessage("");

    if (!otp.trim()) {
      setMessage("Please enter the OTP");
      return;
    }

    try {
      const response = await fetch(
        "https://gitstool.in/liquor/shop_app/otp_verify.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            mob_no: mobile.trim(),
            otp_code: otp.trim(),
          }),
        }
      );

      const result = await response.json();
      console.log("Verify response:", result);

     if (result.status === "success") {
        // Save login state
        localStorage.setItem("isLoggedIn", "true");
        localStorage.setItem("userMobile", mobile.trim());

        setMessage("Login successful!");

        const redirectPath = location.state?.from || "/shop";

        setTimeout(() => {
          navigate(redirectPath);
        }, 800);
      }  else {
        setMessage(result.message || "OTP verification failed");
      }
    } catch (error) {
      console.error("Verify error:", error);
      setMessage("Error verifying OTP");
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-avatar">
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="50"
    height="50"
    viewBox="0 0 24 24"
    fill="#618967"
  >
    <circle cx="12" cy="8" r="4"></circle>
    <path d="M4 20c0-4 4-6 8-6s8 2 8 6"></path>
  </svg>
</div>
        <h2 className="login-title">User Login</h2>

        {/* Mobile Input */}
        <input
          type="tel"
          placeholder="Enter Registered Mobile Number"
          className="login-input"
          value={mobile}
          onChange={(e) => setMobile(e.target.value)}
        />

        {/* Send OTP Button */}
        {!otpSent && (
          <button className="login-button" onClick={handleSendOtp}>
            Send OTP
          </button>
        )}

        {/* OTP Section */}
        {otpSent && (
          <>
 <div className="otp-field">
  <input
    type={showOtp ? "text" : "password"}
    placeholder="Enter OTP"
    className="login-input"
    value={otp}
    onChange={(e) => setOtp(e.target.value)}
  />
{otp.length > 0 && (

  <svg
    className="eye-icon"
    onClick={() => setShowOtp(!showOtp)}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <path
      d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
      fill="none"
      stroke="black"
      strokeWidth="2"
    />
    <circle cx="12" cy="12" r="3" fill="black" />
  </svg> )}
</div>

            <button
              className="login-button"
              onClick={handleVerifyOtp}
            >
              Verify OTP
            </button>
          </>
        )}

        {/* Message */}
        {message && <p className="login-message">{message}</p>}
      </div>
    </div>
  );
};

export default PageLogin;
